(function () {
  /** @param {HTMLElement} wrapper */
  function init(wrapper) {
    if (wrapper.dataset.radicalAccountInited) return;
    wrapper.dataset.radicalAccountInited = '1';

    /** @type {HTMLElement | null} */
    var trigger = wrapper.querySelector('[data-radical-account-trigger]');
    /** @type {HTMLElement | null} */
    var panel = wrapper.querySelector('[data-radical-account-panel]');
    if (!(trigger instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
    /** @type {HTMLElement} */
    var triggerEl = trigger;
    /** @type {HTMLElement} */
    var panelEl = panel;

    function isOpen() {
      return !panelEl.hasAttribute('hidden');
    }

    function close() {
      panelEl.setAttribute('hidden', '');
      triggerEl.setAttribute('aria-expanded', 'false');
    }

    function open() {
      panelEl.removeAttribute('hidden');
      triggerEl.setAttribute('aria-expanded', 'true');
    }

    triggerEl.addEventListener('click', /** @param {MouseEvent} e */ function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) close();
      else open();
    });

    wrapper.addEventListener(
      'click',
      /** @param {MouseEvent} e */ function (e) {
        // Keep default browser behavior for modified/middle clicks.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (!(e.target instanceof Element)) return;

        var link = e.target.closest('a[data-account-tab-target]');
        if (!(link instanceof HTMLAnchorElement) || !wrapper.contains(link)) return;

        var targetUrl = link.getAttribute('data-account-tab-url') || link.getAttribute('href');
        if (!targetUrl) {
          var tabTarget = link.getAttribute('data-account-tab-target');
          if (!tabTarget) return;
          targetUrl = '/pages/account#' + tabTarget;
        }

        e.preventDefault();
        e.stopPropagation();
        close();
        window.location.href = targetUrl;
      },
      true
    );

    document.addEventListener('click', /** @param {MouseEvent} e */ function (e) {
      if (!(e.target instanceof Node)) return;
      if (!wrapper.contains(e.target)) close();
    });

    document.addEventListener('keydown', /** @param {KeyboardEvent} e */ function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

  }

  function boot() {
    /** @type {NodeListOf<HTMLElement>} */
    var accountWrappers = document.querySelectorAll('[data-radical-account]');
    accountWrappers.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
